import { LanguageCode } from "../modules/i18n";

export enum Theme {
    Dark = "dark",
    Light = "light",
}

export namespace UIActions {
    export class SetMenuCollapsedState {
        public static readonly type = "[UI] Set menu collapsed state";
        constructor(public isCollapsed: boolean) {}
    }

    export class SetActiveLanguage {
        public static readonly type = "[UI] Set active language";
        constructor(public languageCode: LanguageCode) {}
    }

    export class SetTheme {
        public static readonly type = "[UI] Set theme";
        constructor(public theme: Theme) {}
    }

    export class EnsureUserInteraction {
        public static readonly type = "[UI] Ensure user interaction";
    }
}
